import { useMemo } from 'react';

import { useCapabilities } from '../../../hooks/use-capability';
import { useOperationProfile, useTenantConfig } from '../config-tenant/use-tenant-config';

import { CONFIG_CATALOG } from './catalog';
import { resolveEstado } from './estado-resolver';

import type { EstadoConfig } from './estado-resolver';

/** Junta as fontes existentes e resolve o estado de todo o catálogo (hub + busca). */
export function useConfigEstados(): Map<string, EstadoConfig | null> {
  const capabilities = useCapabilities();
  const canRead = capabilities.includes('tenant-config-read');
  const tenantConfig = useTenantConfig(canRead);
  const operationProfile = useOperationProfile(canRead);

  return useMemo(() => {
    const fontes = {
      tenantConfig: tenantConfig.data,
      operationProfile: operationProfile.data,
    };
    return new Map(CONFIG_CATALOG.map((i) => [i.id, resolveEstado(i, fontes, capabilities)]));
  }, [tenantConfig.data, operationProfile.data, capabilities]);
}
